import { SvgIcon } from '@mui/material';
import { RoutalPalette } from '@nx-smartmonkey/ui';

interface CommentsIconProps {
  color?: string;
  secondaryColor?: string;
  style?: React.CSSProperties;
}

export default function CommentsIcon({
  color = RoutalPalette.neutral00,
  secondaryColor = RoutalPalette.markerStopColors.completed.dark,
  style = {},
  ...props
}: CommentsIconProps) {
  return (
    <SvgIcon
      {...props}
      viewBox="0 0 12 12"
      style={{
        height: `14px`,
        width: `14px`,
        strokeLinecap: `round`,
        strokeLinejoin: `round`,
        fill: `transparent`,
        ...style,
      }}
    >
      <g>
        <path
          d="M2.12947 8.29668C1.57038 7.35418 1.37458 6.24 1.57884 5.16335C1.7831 4.08671 2.37338 3.12166 3.23882 2.44942C4.10426 1.77719 5.18534 1.44401 6.27906 1.51245C7.37277 1.58089 8.40388 2.04624 9.17877 2.82113C9.95365 3.59601 10.419 4.62712 10.4875 5.72083C10.5559 6.81454 10.2227 7.89562 9.5505 8.76107C8.87827 9.62652 7.91322 10.2168 6.83658 10.4211C5.75993 10.6253 4.64575 10.4295 3.70324 9.87044L3.70325 9.8704L2.14904 10.3145C2.08474 10.3328 2.01669 10.3337 1.95195 10.3169C1.88721 10.3001 1.82814 10.2663 1.78085 10.2191C1.73356 10.1718 1.69978 10.1127 1.68301 10.048C1.66623 9.98321 1.66707 9.91517 1.68545 9.85087L2.12947 8.29668Z"
          fill={color}
          stroke={color}
        />
        <path d="M4.2981 4.17163H7.70174" stroke={secondaryColor} />
        <path d="M4.2981 6.07568H7.70174" stroke={secondaryColor} />
        <path d="M4.2981 7.83228H7.70174" stroke={secondaryColor} />
      </g>
    </SvgIcon>
  );
}
